var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      staticClass: "invoice-details-form m-auto",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit.apply(null, arguments)
        },
      },
    },
    [
      _vm.currentUser.role === "ADMIN"
        ? _c(
            "div",
            { staticClass: "invoice-select mb-5" },
            [
              _c("strong", { staticClass: "flex items-center" }, [
                _c(
                  "label",
                  {
                    staticClass:
                      "flex invoice-label items-center text-base font-normal ml-1 mb-2 font-outfit",
                  },
                  [
                    _c("span", { staticClass: "text-red-600 mx-0.5" }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" Select resource "),
                    _c(
                      "Tooltip",
                      {
                        staticClass: "flex items-center",
                        attrs: {
                          variant: _vm.TooltipVariants.DARK,
                          title:
                            "Please select the resource for whom you are submitting an invoice.",
                          tooltipClasses: "w-56",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "inline-block mx-1" },
                          [_c("InfoIcon")],
                          1
                        ),
                      ]
                    ),
                    _c("span", [_vm._v(":")]),
                  ],
                  1
                ),
              ]),
              _c("FormSelect", {
                staticClass: "invoice-select m-0",
                class: [_vm.resourceClasses],
                attrs: {
                  id: "resourceSelect",
                  name: "resourceSelect",
                  options: _vm.resourceOptions,
                  placeholder: "Type to search resources",
                  isLoading: _vm.loadingCompanies,
                },
                on: {
                  close: function ($event) {
                    return _vm.validateField("resource_id")
                  },
                },
                model: {
                  value: _vm.form.resource_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "resource_id", $$v)
                  },
                  expression: "form.resource_id",
                },
              }),
              _vm.validationErrors?.resource_id
                ? _c("span", { staticClass: "input-error text-red-600" }, [
                    _vm._v(_vm._s(_vm.validationErrors?.resource_id)),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.currentUser.role !== "ADMIN"
        ? _c(
            "div",
            { staticClass: "invoice-select mb-5" },
            [
              _c("strong", { staticClass: "flex items-center" }, [
                _c(
                  "label",
                  {
                    staticClass:
                      "flex invoice-label items-center text-base font-normal ml-1 mb-2 font-outfit",
                  },
                  [
                    _c("span", { staticClass: "text-red-600 mx-0.5" }, [
                      _vm._v("*"),
                    ]),
                    _vm._v(" Select Company "),
                    _c(
                      "Tooltip",
                      {
                        staticClass: "flex items-center",
                        attrs: {
                          variant: _vm.TooltipVariants.DARK,
                          title:
                            "Select which company you are submitting an invoice to.",
                          tooltipClasses: "w-56",
                          placement: "top",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "inline-block mx-1 align-middle" },
                          [_c("InfoIcon")],
                          1
                        ),
                      ]
                    ),
                    _c("span", [_vm._v(":")]),
                  ],
                  1
                ),
              ]),
              _c("FormSelect", {
                staticClass: "invoice-select m-0",
                class: [_vm.companyClasses],
                attrs: {
                  id: "companySelect",
                  name: "companySelect",
                  options: _vm.companyOptions,
                  placeholder: "Type to search companies",
                  isLoading: _vm.loadingCompanies,
                },
                on: {
                  close: function ($event) {
                    return _vm.validateField("company_id")
                  },
                },
                model: {
                  value: _vm.form.company_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "company_id", $$v)
                  },
                  expression: "form.company_id",
                },
              }),
              _vm.validationErrors?.company_id
                ? _c("span", { staticClass: "input-error text-red-600" }, [
                    _vm._v(_vm._s(_vm.validationErrors?.company_id)),
                  ])
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "invoice-select mb-5" },
        [
          _c("strong", { staticClass: "flex items-center font-outfit" }, [
            _c(
              "label",
              {
                staticClass:
                  "flex invoice-label items-center text-base font-normal ml-1 mb-2",
              },
              [
                _c("span", { staticClass: "text-red-600 mx-0.5" }, [
                  _vm._v("*"),
                ]),
                _vm._v(" Select Client "),
                _c(
                  "Tooltip",
                  {
                    staticClass: "flex items-center",
                    attrs: {
                      variant: _vm.TooltipVariants.DARK,
                      title: "The Client that this invoice pertains to.",
                      tooltipClasses: "w-56",
                      placement: "top",
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "inline-block mx-1" },
                      [_c("InfoIcon")],
                      1
                    ),
                  ]
                ),
                _c("span", [_vm._v(":")]),
              ],
              1
            ),
          ]),
          _c("FormSelect", {
            staticClass: "invoice-select m-0",
            class: [_vm.projectClasses],
            attrs: {
              id: "project_id",
              name: "client_id",
              disabled: _vm.form.company_id === null,
              options: _vm.projectOptions,
              placeholder: "Select Client",
            },
            on: {
              close: function ($event) {
                return _vm.validateField("project_id")
              },
            },
            model: {
              value: _vm.form.project_id,
              callback: function ($$v) {
                _vm.$set(_vm.form, "project_id", $$v)
              },
              expression: "form.project_id",
            },
          }),
          _vm.validationErrors?.project_id
            ? _c("span", { staticClass: "input-error text-red-600" }, [
                _vm._v(_vm._s(_vm.validationErrors?.project_id)),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "invoice-input relative mb-5" },
        [
          _c("strong", { staticClass: "flex items-center" }, [
            _c(
              "label",
              {
                staticClass:
                  "flex invoice-label items-center text-base font-normal ml-1 mb-2 font-outfit text-black",
              },
              [
                _c("span", { staticClass: "text-red-600 mx-0.5" }, [
                  _vm._v("*"),
                ]),
                _vm._v(" Enter invoice reference number "),
                _c(
                  "Tooltip",
                  {
                    staticClass: "flex items-center",
                    attrs: {
                      variant: _vm.TooltipVariants.DARK,
                      title:
                        "The reference number provided by the third party platform on the original invoice.",
                      tooltipClasses: "w-56",
                      placement: "top",
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "inline-block mx-1" },
                      [_c("InfoIcon")],
                      1
                    ),
                  ]
                ),
                _c("span", [_vm._v(":")]),
              ],
              1
            ),
          ]),
          _c("FormInput", {
            class: [
              "invoice-input",
              { "input-error": _vm.validationErrors?.invoice_ref },
            ],
            attrs: {
              id: "invoice_ref",
              name: "invoice_ref",
              allowDecimal: "false",
              placeholder: "Enter invoice reference number",
              maxlength: "100",
            },
            on: {
              blur: function ($event) {
                return _vm.validateField("invoice_ref")
              },
            },
            model: {
              value: _vm.form.invoice_ref,
              callback: function ($$v) {
                _vm.$set(_vm.form, "invoice_ref", $$v)
              },
              expression: "form.invoice_ref",
            },
          }),
          _vm.validationErrors?.invoice_ref
            ? _c("span", { staticClass: "input-error text-red-600" }, [
                _vm._v(_vm._s(_vm.validationErrors?.invoice_ref)),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "mb-5" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "invoice-file-upload rounded-lg p-5 relative" },
          [
            _c(
              "div",
              { staticClass: "file-upload-area mb-4" },
              [
                _c("FileUpload", {
                  attrs: { record: _vm.form },
                  on: {
                    handleFileChange: _vm.handleFileChange,
                    blur: function ($event) {
                      return _vm.validateField("external_link")
                    },
                  },
                }),
              ],
              1
            ),
            !_vm.form.file
              ? _c(
                  "div",
                  {
                    staticClass:
                      "widget-square relative overflow-hidden text-center mb-1.5",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "square inline-block px-2.5 text-sm relative z-10 leading-5",
                      },
                      [_vm._v(" or ")]
                    ),
                  ]
                )
              : _vm._e(),
            !_vm.form.file
              ? _c(
                  "div",
                  { staticClass: "invoice-input" },
                  [
                    _c("strong", { staticClass: "flex items-center" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "flex invoice-label items-center font-normal ml-1 mb-1 text-sm font-outfit",
                        },
                        [
                          _vm._v(" Import from URL "),
                          _c(
                            "Tooltip",
                            {
                              staticClass: "flex items-center",
                              attrs: {
                                variant: _vm.TooltipVariants.DARK,
                                title:
                                  "Sharable link from the 3rd party invoicing system used to create the invoice file.",
                                tooltipClasses: "w-56",
                                placement: "top",
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "inline-block mx-1" },
                                [_c("InfoIcon")],
                                1
                              ),
                            ]
                          ),
                          _c("span", [_vm._v(":")]),
                        ],
                        1
                      ),
                    ]),
                    _c("FormInput", {
                      staticClass: "invoice-input",
                      class: {
                        "input-error": _vm.validationErrors?.external_link,
                      },
                      attrs: {
                        id: "external_link",
                        name: "external_link",
                        allowDecimal: "false",
                        placeholder: "https://invoice.com/wefwemk?11=",
                        disabled: _vm.isfileDisable,
                      },
                      on: {
                        blur: function ($event) {
                          return _vm.validateField("external_link")
                        },
                      },
                      model: {
                        value: _vm.form.external_link,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "external_link", $$v)
                        },
                        expression: "form.external_link",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
        _vm.validationErrors?.external_link
          ? _c("span", { staticClass: "input-error text-red-600" }, [
              _vm._v(_vm._s(_vm.validationErrors?.external_link)),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "invoice-input relative mb-5" },
        [
          _c("strong", { staticClass: "flex items-center" }, [
            _c(
              "label",
              {
                staticClass:
                  "flex invoice-label items-center text-base font-normal ml-1 mb-2 font-outfit text-black",
              },
              [
                _c("span", { staticClass: "text-red-600 mx-0.5" }, [
                  _vm._v("*"),
                ]),
                _vm._v(" Rate "),
                _c(
                  "Tooltip",
                  {
                    staticClass: "flex items-center",
                    attrs: {
                      variant: _vm.TooltipVariants.DARK,
                      title:
                        "The rate is the agreed upon amount you will be billing the company.",
                      tooltipClasses: "w-56",
                      placement: "top",
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "inline-block mx-1" },
                      [_c("InfoIcon")],
                      1
                    ),
                  ]
                ),
                _c("span", [_vm._v(":")]),
              ],
              1
            ),
          ]),
          _c("FormInput", {
            class: [
              "invoice-input",
              { "input-error": _vm.validationErrors?.rate },
            ],
            attrs: {
              id: "rate",
              name: "rate",
              allowDecimal: "true",
              type: "text",
              min: "0",
              placeholder: "Input invoice rate",
            },
            on: {
              blur: function ($event) {
                return _vm.validateField("rate")
              },
            },
            model: {
              value: _vm.form.rate,
              callback: function ($$v) {
                _vm.$set(_vm.form, "rate", $$v)
              },
              expression: "form.rate",
            },
          }),
          _vm.validationErrors?.rate
            ? _c("span", { staticClass: "input-error text-red-600" }, [
                _vm._v(_vm._s(_vm.validationErrors?.rate)),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "invoice-input relative mb-5" },
        [
          _c("strong", { staticClass: "flex items-center" }, [
            _c(
              "label",
              {
                staticClass:
                  "flex invoice-label items-center text-base font-normal ml-1 mb-2 font-outfit text-black",
              },
              [
                _vm._v(" Total invoice hours "),
                _c(
                  "Tooltip",
                  {
                    staticClass: "flex items-center",
                    attrs: {
                      variant: _vm.TooltipVariants.DARK,
                      title:
                        "The total amount of hours tracked and being submitted in this invoice.",
                      tooltipClasses: "w-56",
                      placement: "top",
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "inline-block mx-1" },
                      [_c("InfoIcon")],
                      1
                    ),
                  ]
                ),
                _c("span", [_vm._v(":")]),
              ],
              1
            ),
          ]),
          _c("FormInput", {
            attrs: {
              id: "total_hours",
              name: "total_hours",
              allowDecimal: "true",
              type: "text",
              min: "0",
              placeholder: "Input invoice hours",
            },
            model: {
              value: _vm.form.total_hours,
              callback: function ($$v) {
                _vm.$set(_vm.form, "total_hours", $$v)
              },
              expression: "form.total_hours",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "relative mb-5" },
        [
          _c("strong", { staticClass: "flex items-center" }, [
            _c(
              "label",
              {
                staticClass:
                  "flex invoice-label items-center text-base font-normal ml-1 mb-2 font-outfit",
              },
              [
                _c("span", { staticClass: "text-red-600 mx-0.5" }, [
                  _vm._v("*"),
                ]),
                _vm._v(" Total invoice amount "),
                _c(
                  "Tooltip",
                  {
                    staticClass: "flex items-center",
                    attrs: {
                      variant: _vm.TooltipVariants.DARK,
                      title: "Total invoice amount before tax.",
                      tooltipClasses: "w-56",
                      placement: "top",
                    },
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "inline-block mx-1" },
                      [_c("InfoIcon")],
                      1
                    ),
                  ]
                ),
                _c("span", [_vm._v(":")]),
              ],
              1
            ),
          ]),
          _c("CurrencyInput", {
            staticClass: "invoice-price-select relative m-0",
            class: [
              "currency-input",
              { "input-error": _vm.validationErrors?.total_amount },
            ],
            attrs: {
              id: "total_amount",
              name: "total_amount",
              value: _vm.form.total_amount,
              "selected-currency": _vm.form.currency,
              options: _vm.currencyOptions,
              "validation-rules": "required",
              placeholder: "00.00",
              "container-class": "currency-input-container",
              "select-class": "currency-select",
            },
            on: {
              input: function ($event) {
                _vm.form.total_amount = $event
              },
              "update:currency": function ($event) {
                _vm.form.currency = $event
              },
              blur: function ($event) {
                return _vm.validateField("total_amount")
              },
            },
          }),
          _vm.validationErrors?.total_amount
            ? _c("span", { staticClass: "input-error text-red-600" }, [
                _vm._v(_vm._s(_vm.validationErrors?.total_amount)),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "invoice-form-button" }, [
        _c(
          "div",
          { staticClass: "invoice-form-button-wrap" },
          [
            _c("UiButton", {
              attrs: {
                buttonText: "Cancel",
                buttonClasses:
                  "px-2 pr-3.5 pl-3.5 customHeight40 invoice-steps-buttons",
                variant: "white",
              },
              on: { click: _vm.handleClick },
            }),
            _c("UiButton", {
              attrs: {
                type: "submit",
                buttonText: _vm.isEditMode() ? "Save & update" : "Continue",
                buttonClasses:
                  "px-2 pr-3.5 pl-3.5 customHeight40 invoice-steps-buttons",
                variant: "black",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("strong", { staticClass: "flex items-center" }, [
      _c(
        "label",
        {
          staticClass:
            "flex invoice-label items-center text-base font-normal ml-1 mb-2 font-outfit",
        },
        [
          _c("span", { staticClass: "text-red-600 mx-0.5" }, [_vm._v("*")]),
          _vm._v(" Invoice File "),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }